import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';

@Component({
  selector: 'app-viewgrievancereply',
  templateUrl: './viewgrievancereply.component.html',
  styleUrl: './viewgrievancereply.component.css'
})
export class ViewgrievancereplyComponent {
  form: FormGroup;
  GrievanceList: any[] = [];
  grievanceReply: any[] = [];
  grievanceId = sessionStorage.getItem("GrievanceId");
  statusList: any[] = [];
  showDownloadBtn = false;
  showDownloadBtnMSME = false;

  grievanceDocumentFile: File | null = null;
  grievanceDocumentfileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  maxSizeInMB = 10;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    public dialog : MatDialog) {
    this.form = this.fb.group({
      reply: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(500)]),
      status: new FormControl('', [Validators.required]),
      documents: this.fb.array([])
    });

    this.form = this.fb.group({
      msmeGrievanceId: new FormControl(''),
      grievanceName: new FormControl(''),
      subject: new FormControl(''),
      description: new FormControl(''),
      createdDate: new FormControl(''),
      documentName: new FormControl(''),
      documentPath: new FormControl(''),
      reply: new FormControl(''),
      resolvedDocumentName: new FormControl(''),
      resolvedDocumentPath: new FormControl(''),
      status: new FormControl(''),
    });
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    if (this.grievanceId) {
      this.LoadDetails(this.grievanceId);
      this.LoadGrievanceReply(this.grievanceId);
    }
    this.form.disable();
  }

  LoadDetails(grievanceId: string) {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCEDETAILSBYID, { grievanceId }).subscribe(
      (result) => {
        if (result.status) {
          this.GrievanceList = result.data;
          this.form.patchValue(this.GrievanceList);
          if (result.data.documentPath!==null) {
            this.showDownloadBtnMSME = true;
          }
        }
      }
    );
  }

  LoadGrievanceReply(grievanceId: string) {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCEREPLY, { grievanceId }).subscribe(
      (result) => {
        if (result.status) {
          this.grievanceReply = result.data;
          this.form.patchValue(this.grievanceReply);
          if (result.data.resolvedDocumentName != null) {
            this.showDownloadBtn = true;
          }          
        }
      }
    );
  }

  onDownload() {
    var filePath = this.form.get('documentPath')?.value;
    var fileName = this.form.get('documentName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onReplyDownload() {
    var filePath = this.form.get('resolvedDocumentPath')?.value;
    var fileName = this.form.get('resolvedDocumentName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'ReviewerComment_'+fileName  || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  Reset() {
    this.router.navigate(['/grievanceDashboard']);
  }


  openFilePreviewDialog(): void {
    var filePath = this.form.get('documentPath')?.value;
    var fileName = this.form.get('documentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height : '80',
          data: { fileUrl, fileName }  
        });
      }
    });
  }

  openReplyFilePreviewDialog(): void {
    var filePath = this.form.get('resolvedDocumentPath')?.value;
    var fileName = this.form.get('resolvedDocumentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }
}
